module.exports = __webpack_public_path__ + "static/media/driver.a758014a.png";